(() => {
  'use strict';
  const scopes = new Set();
  let pending = false;
  const context = () => {
    try { return JSON.parse(document.getElementById('mavelle-product-context')?.textContent || 'null'); }
    catch { return null; }
  };
  const config = () => {
    try {
      const data = JSON.parse(document.getElementById('mavelle-promotions')?.textContent || '[]');
      const rules = Array.isArray(data) ? data : data?.rules;
      return { rules: Array.isArray(rules) ? rules : [], timezone: data?.timezone || 'America/Los_Angeles' };
    } catch { return { rules: [], timezone: 'America/Los_Angeles' }; }
  };
  const dayInZone = (now, timezone) => {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: timezone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now);
    const get = type => parts.find(part => part.type === type).value;
    return `${get('year')}-${get('month')}-${get('day')}`;
  };
  const active = (rule, now, timezone) => {
    if (!(Number(rule.rate) > 0 && Number(rule.rate) < 1)) return false;
    if (rule.startsAt && (!Number.isFinite(Date.parse(rule.startsAt)) || now.getTime() < Date.parse(rule.startsAt))) return false;
    if (rule.endsAt && (!Number.isFinite(Date.parse(rule.endsAt)) || now.getTime() > Date.parse(rule.endsAt))) return false;
    const day = dayInZone(now, timezone);
    return (!rule.from || day >= rule.from) && (!rule.to || day <= rule.to);
  };
  const norm = value => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  const ruleFor = (host, cfg) => {
    const master = context();
    const card = host.closest('product-card');
    if (!card && !host.closest('main, sticky-add-to-cart, quick-add-dialog, featured-product-information')) return null;
    const id = String(card?.dataset.productId || host.closest('product-price')?.dataset.productId || master?.id || '').split('/').pop();
    const tags = new Set(card ? (card.dataset.productTags || '').split('|').map(norm) : (master?.tags || []).map(norm));
    const type = String(card?.dataset.productType || master?.type || '').toLowerCase();
    return cfg.rules.find(rule => {
      if (!active(rule, new Date(), cfg.timezone)) return false;
      if ((rule.excludeTags || []).map(norm).some(tag => tags.has(tag))) return false;
      if (rule.productIds?.length) return rule.productIds.some(value => String(value).split('/').pop() === id);
      return (rule.tags || []).map(norm).some(tag => tags.has(tag)) || (rule.productTypes || []).some(value => type.includes(String(value).toLowerCase()));
    }) || null;
  };
  const money = cents => {
    const currency = window.Shopify?.currency?.active || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(cents / 100); }
    catch { return '$' + (cents / 100).toFixed(2); }
  };
  const writeText = (element, value) => { if (element.textContent !== value) element.textContent = value; };
  const render = scope => {
    if (!scope?.isConnected) return;
    const cfg = config();
    const prices = scope.matches?.('[data-mavelle-price-cents]') ? [scope] : [...scope.querySelectorAll('[data-mavelle-price-cents]')];
    prices.forEach(price => {
      if (price.closest('.price__hidden')) return;
      const host = price.parentElement;
      const cents = Number(price.dataset.mavellePriceCents);
      const max = Number(price.dataset.mavelleMaxPriceCents || cents);
      if (!host || !Number.isFinite(cents) || cents < 0) return;
      const rule = ruleFor(price, cfg);
      const existing = host.querySelector(':scope > .mavelle-promo-now');
      const card = price.closest('product-card');
      const media = card?.querySelector('.card-gallery') || document.querySelector('main .product-media-container');
      if (!rule) {
        existing?.remove();
        price.classList.remove('mavelle-promo-was');
        host.classList.remove('mavelle-promo-wrap');
        host.removeAttribute('data-mavelle-promo-ready');
        media?.querySelector('.mavelle-promo-badge')?.remove();
        return;
      }
      const discounted = Math.round(cents * (1 - Number(rule.rate)));
      const discountedMax = Math.round(max * (1 - Number(rule.rate)));
      const label = max > cents ? `${money(discounted)} - ${money(discountedMax)}` : money(discounted);
      let sale = existing;
      if (!sale) {
        sale = document.createElement('span');
        sale.className = 'mavelle-promo-now';
        sale.dataset.mavelleOwnMutation = 'true';
        host.insertBefore(sale, price);
      }
      writeText(sale, label);
      host.classList.add('mavelle-promo-wrap');
      host.setAttribute('data-mavelle-promo-ready', 'true');
      price.classList.add('mavelle-promo-was');
      if (media) {
        let badge = media.querySelector('.mavelle-promo-badge');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'mavelle-promo-badge';
          badge.dataset.mavelleOwnMutation = 'true';
          media.appendChild(badge);
        }
        writeText(badge, rule.label || `${Math.round(rule.rate * 100)}% OFF`);
      }
    });
  };
  const queue = scope => {
    scopes.add(scope || document);
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(() => {
      pending = false;
      const batch = [...scopes]; scopes.clear();
      batch.forEach(render);
    });
  };
  const start = () => {
    render(document);
    const main = document.getElementById('MainContent');
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => mutation.addedNodes.forEach(node => {
        if (!(node instanceof Element) || node.dataset.mavelleOwnMutation) return;
        if (node.matches('product-card, product-price, [ref="priceContainer"], [data-mavelle-price-cents]') || node.querySelector('product-card, product-price, [data-mavelle-price-cents]')) {
          queue(node.closest('product-card, product-price') || node);
        }
      }));
    });
    if (main) observer.observe(main, { childList: true, subtree: true });
    document.querySelectorAll('quick-add-dialog').forEach(dialog => observer.observe(dialog, { childList: true, subtree: true }));
    document.addEventListener('variant:update', event => queue(event.target.closest?.('.shopify-section, quick-add-dialog, dialog') || main));
    document.addEventListener('shopify:section:load', event => queue(event.target));
    // Recheck a long-lived page at campaign boundaries without observing the whole document.
    window.setInterval(() => { if (document.visibilityState === 'visible') queue(main || document); }, 60000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
